import { memo } from 'react';
import SearchAutocompleteTaskComponent from './SearchAutocompleteTaskComponent';
import { StepViewComponentProps } from '../../stepDescriptor/types';

function SearchAutocompletePinnedViewComponent(props: StepViewComponentProps) {
  return <SearchAutocompleteTaskComponent {...props} isPinnable isPinnedView />;
}
export default memo(SearchAutocompletePinnedViewComponent);
